import { MouseEventHandler, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './styles.module.scss';

type LineClampToggleProps = {
  initialClamped: boolean;
  onClampChange: (clamped: boolean) => void;
};

export const LineEllipsis = ({ initialClamped, onClampChange }: LineClampToggleProps) => {
  const [clamped, setClamped] = useState<boolean>();

  const handleToggleReadMore: MouseEventHandler<HTMLSpanElement> = (e) => {
    // Click event should not propagate to parent elements
    e.stopPropagation();

    if (clamped === undefined) {
      setClamped(false);
      onClampChange(false);
    } else {
      setClamped(!clamped);
      onClampChange(!clamped);
    }
  };

  if (clamped === undefined && !initialClamped) {
    return null;
  }

  return (
    <span className={styles.text} onClick={handleToggleReadMore}>
      {clamped || clamped === undefined ? (
        <FormattedMessage id="editor.comments.readMore" />
      ) : (
        <FormattedMessage id="editor.comments.readLess" />
      )}
    </span>
  );
};
